export default __webpack_public_path__ + "static/media/j.crew1.e32bcc75.png";